import api from '@/services/api';
import { TPostServiceDivision } from '@/services/servicesDivision';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const usePostServiceDivision = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const navigate = useNavigate();
  return useMutation({
    mutationKey: ['create-service-division'],
    mutationFn: (payload: TPostServiceDivision) =>
      api.serviceDivision.postServiceDivision(payload),
    onError: (error) => {
      const errorMessage = error.message;
      toast.error(t('toast.error', { errorMessage }));
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['services']
      });
      toast.success(t('toast.createServiceDivision'));
      navigate(-1);
    },
    retry: false
  });
};

export default usePostServiceDivision;
